module.exports = __webpack_public_path__ + "static/media/hero-img.87ded71c.png";